module.exports = __webpack_public_path__ + "img/data-variable.71224bb5.svg";